import '@fontsource-variable/inter';
import '@fontsource-variable/manrope';
import './styles.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { createQueryClient } from '@kts/client';
import { bootTheme } from '@kts/ui';
import { AuthBoot } from './app/guards';
import { router } from './app/router';
import { setupI18n } from './i18n';

bootTheme();
setupI18n();
const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthBoot>
        <RouterProvider router={router} />
      </AuthBoot>
    </QueryClientProvider>
  </StrictMode>,
);
